import { FetchTimerResponseType } from '../../types/FetchTimerReponse'

export const FetchTimerResponse: FetchTimerResponseType = {
  timerState: 'none',
  endTimestamp: null,
  stopTime: null,
  workTime: null,
  breakTime: null
}
